
import React from "react";

import {inject, observer} from "mobx-react";
import {toJS} from "mobx";
import AkindaLogo from '../../assets/img/sa/akinda_logo.png';
import OkLogo from '../../assets/img/sa/ok.png';
import PhotoSelfie from "../../assets/img/sa/selfie_album_top.png";

import '../../assets/css/utenti.css';


@inject('store')
@observer
class ConfirmPhotoUpload extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
        this.store = this.props.store.appState;

    };


    componentDidMount() {
        document.body.style.background = '#235F84';
    }


    render() {

        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);
        
        let selecttext = '';
        if (DEFAULT_TEXT.back_album_button !== undefined) {
            selecttext = DEFAULT_TEXT.back_album_button.toUpperCase();
        }

        return (
            <div style={{height: '100vh'}} className={'main-div'}>
                <div className={'akinda-logo'}>
                    <img className={'img-akindalogo'} src={AkindaLogo} alt='Akinda Logo'/>
                </div>

                <div className={'wrapper-div'}>
                    <div>
                        <img className={'img-photoselfie'} src={PhotoSelfie} alt='Selfie'/>
                    </div>
                    <div className={'introduction'}>
                        <img className={'img-oklogo'} src={OkLogo} width={'100%'} alt='ok'/>
                        <h2 className={'complimenti'}>
                            {DEFAULT_TEXT.compliments}
                        </h2>
                        <p className={'para-comp fontRoboto'} style={{'paddingBottom':'0' }}>{DEFAULT_TEXT.photo_uploaded_ok}</p>


                        <div className={'backtoalbum_wrp'}>
                            
                            <div>
                                <hr className='horizontal-line-termini' style={{'marginTop':'1rem', 'marginBottom':'1.5rem' }}/>
                            </div>

                            {/* <p className={'para-comp fontRoboto'}  style={{'paddingBottom':'1rem' }} >Vuoi caricare altre foto? <br />Torna alla pagina della sessione scatti</p> */}
                            
                            <p className={'para-comp fontRoboto'}  style={{'paddingBottom':'1rem' }} dangerouslySetInnerHTML={{__html: DEFAULT_TEXT.vuoi_altro}} >
                            </p>
                            
                            <div 
                                className={'send-button fontRoboto'} 
                                onClick={() => this.props.history.goBack() }
                            >
                                {selecttext}
                            </div>
                            <br />
                        </div>

                    </div>
                    
                </div>
            </div>
        )
    }

}


export default ConfirmPhotoUpload;




// WEBPACK FOOTER //
// ./src/views/Users/ConfirmUpload.jsx